import TYPE from "./mutations_type";

export default {
  [TYPE.SET_USER_INFO](store, obj) {
    store.userInfo = obj;
  },

  [TYPE.SET_ORIGANIZATION](store, arr) {
    store.origanization = arr;
  },

  [TYPE.SET_HEADER_INFO](store, info = {}) {
    store.headerInfo = info;
  },

  [TYPE.UPDATE_SYSTEMSET_DATA](state, data = 0) {
    let { stateName, fieldData } = data;
    state[stateName] = {
      ...state[stateName],
      ...fieldData,
    };
  },

  [TYPE.SET_WX_CONFIG](state, data) {
    state.wxConfig = { ...data }
  },
};
